export type DateResource = string;
export type DateIsoString = string;

export const defaultDateIsoString = new Date().toISOString();
